module.exports = __webpack_public_path__ + "img/vegan.5f3256f3.svg";